<template>
	<div class="contentPage roles">
		<div>
			<div class="roles_top">
				<div class="roles_top-title">Roles</div>
				<custom-btn
						text="SAVE"
						custom-class="apply"
						@updateEvent="saveActionRole"
				></custom-btn>
			</div>
			<row margin="0" class="roles_block" justify-content="space-between">
				<row margin="0" flex="inline-flex" width="initial">
<!--					<field-->
<!--							margin="0 10px 0 0"-->
<!--							width="300px"-->
<!--							label="Role name"-->
<!--							placeholder="Select role name"-->
<!--							item-text="name"-->
<!--							@updateSelect="getActionPermissions"-->
<!--							:autocompleteValue="roleSelect"-->
<!--							:items="roleList"-->
<!--							:is-disabled="!!customer_id"-->
<!--							is-select-->
<!--							:is-clearable="false"-->
<!--					></field>-->
					<field
							margin="0 10px 0 0"
							width="300px"
							label="Role"
							placeholder="Select role"
							@updateAutocomplete="getActionPermissions"
							:autocompleteValue="roleSelect"
							:items="roleList"
							:isClearable="false"
							is-autocomplete
							item-text="name"
							item-value="id"
					></field>
					<field
							v-if="isRoleCustomer"
							margin="0 10px 0 0"
							width="300px"
							label="Customer"
							placeholder="Select customer"
							@updateSelect="onSubCustomer"
							:autocompleteValue="customerFilter"
							:items="permissionCustomersFilter"
							:is-disabled="!!customer_id"
							is-select
							:is-clearable="false"
					></field>
					<field
							v-if="isRoleCustomer"
							margin="0"
							width="180px"
							label="Subrole"
							placeholder="Select subrole"
							@updateSelect="onSubCustomerRole"
							:autocompleteValue="subrole"
							:items="subroleCustomers"
							item-text="name"
							:is-disabled="!!customer_id"
							is-select
							:is-clearable="false"
					></field>
				</row>
				<div>
					<custom-btn
							v-if="permissionsSection['11']"
							margin="0 10px 0 0"
							text="delete role"
							custom-class="cancel"
							@updateEvent="onDeletePopup"
					></custom-btn>
					<custom-btn
							v-show="permissionsSection['8']"
							margin="0"
							text="CREATE NEW ROLE"
							custom-class="apply"
							@updateEvent="onCreateRole(1)"
					></custom-btn>
				</div>
			</row>
		</div>
		<div class="roles_treeView rolesScroll">
			<v-treeview
					selected-color="green"
					:items="permissions"
					class="permissions-list"
					expand-icon="mdi-chevron-down"
					on-icon="mdi-bookmark"
					off-icon="mdi-bookmark-outline"
					:open.sync="open"
					return-object
					danse
					shaped
			>
				<template v-slot:label="{ item }">
					<div class="treeCheckBox">
						<v-checkbox
								danse
								hide-details
								:readonly="!permissionsSection['9']"
								:disabled="item.hide"
								class="treeCheckBox mt-0"
								v-model="item.selected"
								:label="item.name"
								@change="changeChild(item)"
						></v-checkbox>
					</div>
				</template>
			</v-treeview>
		</div>
		<remove-block
				v-if="isRemove"
				z-index="100"
				@updateRemoveItem="onRemoveItem"
				@updateRemoveClose="onRemoveClose"
		></remove-block>
		<roles-form
				v-if="isRolesForm"
				:defaultCustomerId="customer_id"
				:permissionCustomers="permissionCustomers"
				@updateCloseDialog="onCloseDialog"
				@updateRolesList="onRolesList"
		></roles-form>
	</div>
</template>
<script>
/* eslint-disable */
// vuex
import { mapActions, mapGetters } from "vuex";
// components
import RolesForm from "@/components/Settings/Roles/RolesForm/RolesForm";
import defaultValues from "@/components/Settings/Roles/defaultValues";
// mixins
import removeMixins from "@/mixins/removeMixins";

export default {
	name: "Roles",
	mixins: [ removeMixins ],
	components: { RolesForm },
	computed: {
		...mapGetters([ 'permissionCustomers', 'getPermissionsState', 'subroleCustomers', 'permissionCustomersFilter' ]),
		permissionsSection() {
			return this.$store.getters.permissions;
		},
		isRoleCustomer() {
			return this.roleSelect?.id === 2;
		},
		isCustomer() {
			return this.roleSelect?.id === 2 && this.customerFilter?.id;
		}
	},
	data() {
		return {
			roleList: [],
			roleSelect: null,
			permissions: [],
			open: [ 1, 2 ],
			customerFilter: defaultValues,
			subrole: 0,
			customer_id: null,
			role_id: null,
			isRolesForm: null,
			del: {
				99: [8, 9, 11, 72],
				98: [8, 9, 11, 72],
				97: [8, 72],
				96: [8, 9, 11, 72],
				93: [8, 11, 72],
				'91-92': [8, 9, 11],
				101: [8, 9, 11, 72],
				103: [9, 72],
				104: [8, 9, 11, 72],
				91: [105],
				106: [8, 9, 11, 72],
				118: [72],

				// 89: [8, 9],
				// 82: [9],
				// 95: null, // Полностью удалить элемент 95 из корня
				// 83: [95], // Удалить элемент 95, если он находится в 83
				// "83-95": [8] // Удалить элемент с id 8 внутри 95, который находится в 83
			}
		};
	},
	methods: {
		...mapActions([
			'onPermissionCustomers',
			'actionPreloader',
			'onDeleteRole',
			'setAlert',
			'saveRole',
			'onLogin',
			'getRoles',
			'getPermissions',
			'onCustomersList'
		]),
		onRolesList() {
			this.getActionRole();
		},
		onCloseDialog() {
			this.isRolesForm = false;
		},
		onCreateRole(value) {
			this.isRolesForm = value;
		},
		changeChild(item) {
			if (item.children && !item.selected) {
				const disabledChild = (item) => {
					item.selected = false;
					if (item.children) {
						for (const i of item.children) {
							disabledChild(i);
						}
					}
				};
				disabledChild(item);
			}
		},
		onDeletePopup() {
			this.isRemove = true;
		},
		async onRemoveItem() {
			this.actionPreloader(true);
			const values = this.isRoleCustomer ? this.subrole : this.roleSelect;
			const { status, error } = await this.onDeleteRole(values);
			if (status) {
				await this.getActionRole();
				this.setAlert({ type: "success", message: "Deleting Successfully" });
			} else if (error && error.name) {
				this.setAlert({ type: "error", message: error.name[0] });
			} else {
				this.setAlert({ type: "error", message: "Deleting Error" });
			}

			this.isRemove = false;
			this.actionPreloader(false);
		},
		async saveActionRole() {
			this.actionPreloader(true);
			const values = {
				role: this.subrole || this.roleSelect,
				permissions: this.permissions,
			};
			await this.saveRole(values);
			this.actionPreloader(false);
			this.setAlert({ type: "success", message: "Roles updated successfully" });
			await this.onLogin('');
		},
		getOpen() {
			this.open = [];
			for (const i of this.permissions) {
				this.open.push(i);
			}
		},
		async getActionRole() {
			this.actionPreloader(true);
			const { userGroup, customer_id, role_id } = await this.getRoles();
			this.roleList = userGroup || [];
			this.customer_id = customer_id;
			this.role_id = role_id;

			if (customer_id) {
				this.roleSelect = this.roleList.find(item => item.id === 2);
			} else {
				this.roleSelect = this.roleList[0];
			}

			if (this.roleSelect) await this.getActionPermissions(this.roleSelect);
		},
		getFilteredMap(array) {
			return array.filter(item => {
				if (!item.hide) {
					if (item.children) {
						item.children = this.getFilteredMap(item.children);
					}
					return true;
				}
				return false;
			});
		},
		onAutocomplete({ value, idx }, key) {
			this[key] = value?.id ?? value;
		},
		async getActionPermissions({ value, id }) {
			if (value) this.roleSelect = value;
			const roleId = id ?? value.id;
			this.actionPreloader(true);
			await this.getPermissions(roleId);
			await this.onCustomersList(null);

			if (this.customer_id) {
				this.customerFilter = this.permissionCustomersFilter.find(item => item.id === this.customer_id);
				await this.onSubCustomer(this.customerFilter);
			} else {
				this.customerFilter = defaultValues;
				this.permissions = this.filterPermissions({list: this.getPermissionsState, del: this.del});
				console.log('%c [  this.permissions  ] ', 'color:#bada55', typeof this.permissions, this.permissions );
				this.getOpen();
			}

			this.actionPreloader(false);
			this.subrole = null;
		},
		async onSubCustomer({ value, id }) {
			if (value) this.customerFilter = value;
			const roleId = id ?? value.id;

			if (roleId) {
				await this.onCustomersList(roleId ?? null);
			} else {
				this.onSubCustomerRole({ id: 2 });
			}

			this.permissions = [];
			this.subrole = null;
		},
		onSubCustomerRole({ value, id }) {
			if (value) this.subrole = value;
			const roleId = id ?? value.id;

			this.actionPreloader(true);
			this.getPermissions(roleId).then(() => {
				this.permissions = this.filterPermissions({list: this.getPermissionsState, del: this.del});
				console.log('%c [  this.permissions 2 ] ', 'color:#bada55', typeof this.permissions, this.permissions );
				this.getOpen();
				this.actionPreloader(false);
			});
		},
		filterPermissions({ list, del }) {
			function deepClone(obj) {
				return JSON.parse(JSON.stringify(obj));
			}

			const clonedList = deepClone(list);

			function filterChildren(parent, parentId = null) {
				// Полностью удалить элемент, если в del указан null и он находится в корне
				if (del[parent.id] === null && parentId === null) {
					return null;
				}

				if (parent.children) {
					parent.children = parent.children
					.map(child => filterChildren(child, parent.id)) // Рекурсивно обрабатываем вложенные элементы
					.filter(child => {
						// Удаляем только детей, которые явно указаны для родителя
						if (del[parent.id] && del[parent.id].includes(child.id)) {
							return false;
						}
						// Проверяем, если удаление указано для конкретного родителя
						if (del[`${parentId}-${parent.id}`] && del[`${parentId}-${parent.id}`].includes(child.id)) {
							return false;
						}
						return true;
					});
				}
				return parent;
			}

			return clonedList
			.map(item => filterChildren(item)) // Применяем фильтрацию ко всему массиву
			.filter(Boolean); // Убираем полностью удаленные элементы
		}
	},
	async created() {
		await this.getActionRole();
		await this.onPermissionCustomers();
	}
};
</script>
<style scoped lang="scss">
	@import "roles";
</style>

<style lang="scss">
	@import "rolesGlobal";
</style>

